/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Navbar from "../../../components/Navbar";
import BlogsDashboard from "../../../components/WebsiteBlogs/Management/BlogsDashboard";
import { backendUrlByEnv, LOGIN } from "../../../constants/routes";

const WebsiteBlogsManagement = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);

  useEffect(() => {
    if (!userConfig?.websiteBlogs?.hasManagementAccess) {
      navigate(LOGIN);
    }
  }, []);

  return (
    <>
      <Navbar />
      <BlogsDashboard ROOT_URL={ROOT_URL} BASE_URL={"admin/cp-digest/management"} />
    </>
  );
};

export default WebsiteBlogsManagement;
